export default '0.18.5'



// WEBPACK FOOTER //
// ./version.js